import type { ContentItem } from 'src/types/content';

import { Reveal } from './reveal';

type BenefitGridProps = {
  items: ContentItem[];
};

export function BenefitGrid({ items }: BenefitGridProps) {
  return (
    <div className="benefits">
      {items.map((item) => (
        <Reveal key={item.title} className="benefit">
          <h3>{item.title}</h3>
          <p>{item.text}</p>
        </Reveal>
      ))}
    </div>
  );
}
